enum DriverContractListingByTaxiSortKey {
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  FREE_STOPPING_PERIOD_ASC = "HALTING_TIME_GRACE_PERIOD_ASC",
  FREE_STOPPING_PERIOD_DESC = "HALTING_TIME_GRACE_PERIOD_DESC",
  STOPPING_RATE_ASC = "STOPPING_RATE_ASC",
  STOPPING_RATE_DESC = "STOPPING_RATE_DESC",
  PERIOD_OF_VALIDITY_FROM_ASC = "PERIOD_OF_VALIDITY_FROM_ASC",
  PERIOD_OF_VALIDITY_FROM_DESC = "PERIOD_OF_VALIDITY_FROM_DESC",
  PERIOD_OF_VALIDITY_TO_ASC = "PERIOD_OF_VALIDITY_TO_ASC",
  PERIOD_OF_VALIDITY_TO_DESC = "PERIOD_OF_VALIDITY_TO_DESC",
}

export default DriverContractListingByTaxiSortKey;
